import React from "react";
import { Cell } from "react-md";
import {ChangePasswordCard} from "components/Shared";

const ChangePassword = () => (
  <Cell size={4} offset={4}>
    <ChangePasswordCard/>
  </Cell>
);

export default ChangePassword;
